import React from "react";
import ContactInformationsCustomProperties from "./ContactInformationsCustomProperties";
import ContactInformationsInformations from "./ContactInformationsInformations";
import ContactInformationsSegments from "./ContactInformationsSegments";
import ContactInformationsTags from "./ContactInformationsTags";

export default function ContactInformations({
  data,
  fetching,
  tagsResult,
  segmentsResult,
  customProperties,
  onManageConsent,
}) {
  return (
    <>
      <ContactInformationsInformations
        data={data}
        onManageConsent={onManageConsent}
      />
      <ContactInformationsCustomProperties
        data={customProperties}
        fetching={fetching}
      />
      <ContactInformationsSegments
        data={segmentsResult.data}
        fetching={segmentsResult.fetching}
      />
      <ContactInformationsTags
        data={tagsResult.data}
        fetching={tagsResult.fetching}
      />
    </>
  );
}
